function min(...args) {
  return Math.min(...args);
}

export default min;
